export default __webpack_public_path__ + "static/media/ocshomepagelogo1.f650971b.png";